import React from 'react';

import { PrimaryButton } from '@app/components/button';
import { Hr } from '@app/components/hr';
import { ChevronRightIcon } from '@app/components/icons';

import { CardTabOverlay } from '../card-tab-overlay-container';

export const ExamCardTabOverlay = ({
	show = null,
	stepType = '',
	stepIndex = '',
	labels = {},
	hasCoursePackages,
	hasMatchingCartItem = null,
	onClick,
	onClose,
}) => {
	const [selectedExamDetails, setSelectedExamDetails] = React.useState({});

	React.useEffect(() => {
		const prefix = stepType || 'exam';
		const index = stepIndex ? `-${stepIndex}` : '';

		const examWindow = labels && labels[`${prefix}-exam-window${index}`];
		const title = labels && labels[`${prefix}-exam${index}`];
		const testingLocationType =
			labels && labels[`${prefix}-testing-location-type${index}`];
		const country = labels && labels[`${prefix}-country${index}`];
		const state = labels && labels[`${prefix}-state-${index}`];
		const testingCenter = labels && labels[`${prefix}-testing-center${index}`];
		const program = labels && labels[`${prefix}-program${index}`];

		setSelectedExamDetails({
			examWindow,
			title,
			testingLocationType,
			country,
			state,
			testingCenter,
			program,
		});
	}, [labels, stepType, stepIndex]);

	const resetExamForm = () => onClose('exam');

	const {
		title,
		examWindow,
		testingLocationType,
		country,
		state,
		testingCenter,
		program,
	} = selectedExamDetails;

	return (
		<CardTabOverlay show={show} onClose={resetExamForm}>
			<p className="u-font-family-primary course-panel__title course-panel__title--overlay">
				{title} <strong>has been added to your cart.</strong>
			</p>

			{examWindow && (
				<p className="u-font-family-text course-overlay__help-text">
					Exam Window
					<strong>{examWindow}</strong>
				</p>
			)}

			<dl className="detail-list__container detail-list__container--w-divider detail-list__container--4-col">
				<div className="detail-list__item detail-list__item--sm">
					<dt className="u-text-uppercase detail-list__title">
						Testing Location Type
					</dt>
					<dd className="detail-list__desc">{testingLocationType}</dd>
				</div>

				{testingLocationType === 'On Site' && (
					<>
						<div className="detail-list__item detail-list__item--sm">
							<dt className="u-text-uppercase detail-list__title">Country</dt>
							<dd className="detail-list__desc">{country}</dd>
						</div>

						{state && (
							<div className="detail-list__item detail-list__item--sm">
								<dt className="u-text-uppercase detail-list__title">State</dt>
								<dd className="detail-list__desc">{state}</dd>
							</div>
						)}

						<div className="detail-list__item detail-list__item--sm">
							<dt className="u-text-uppercase detail-list__title">
								Testing Center
							</dt>
							<dd className="detail-list__desc">{testingCenter}</dd>
						</div>
					</>
				)}

				<div className="detail-list__item detail-list__item--sm">
					<dt className="u-text-uppercase detail-list__title">Program</dt>
					<dd className="detail-list__desc">{program}</dd>
				</div>
			</dl>

			{examWindow && examWindow === 'April 15 - June 30, 2020' && (
				<p className="u-font-family-text course-overlay__help-text">
					CE credits may be available for this exam. You will be able to select
					CE in your cart if it is available in your state.
				</p>
			)}

			<Hr neutral />

			{hasMatchingCartItem || !hasCoursePackages ? (
				<>
					<p>
						If you need to update this information, you can do so in the cart.
					</p>
					<a href="/cart" className="btn btn--primary" title="Cart">
						Continue to Cart
					</a>
				</>
			) : (
				<>
					<p className="u-font-family-text course-overlay__help-text">
						You haven&apos;t selected your course materials yet.
						<strong>Would you like to do that now?</strong>
					</p>
					<PrimaryButton onClick={() => onClick(0)}>
						Select Your Materials
					</PrimaryButton>
					<div className="u-margin-top">
						<a href="/cart" className="btn btn--icon btn--text" title="Cart">
							<span>
								Continue to Cart
								<ChevronRightIcon />
							</span>
						</a>
					</div>
				</>
			)}
		</CardTabOverlay>
	);
};
